import { Injectable } from '@angular/core';
import { EventType } from '@angular/router';
import { List } from 'lodash';
import { Observable, map } from 'rxjs';
import {
  BlobFileDownloadRequestModel,
  BlobFileSasUrl
} from '../../models/blob-file-sas-url.model';
import { EventTargetProduct } from '../../models/event-target-product.model';
import { ProgramTypeDisplayNames } from '../../models/event-type.model';
import { PagedResult } from '../../models/page-result.model';
import { PartnerWorkshopHistory } from '../../models/partner-workshop-response.model';
import {
  PartnerListUploadItem,
  CustomerListImportItem
} from '../../models/private-workshop-response.model';
import { ProgramType } from '../../models/program-type.model';
import { EventsApiBase } from '../mcap-events/api-base';
import {
  AgreementPartnerDetails,
  AgreementPartnerDetailsRequest
} from '../../models/agreement-partner-details.model';

@Injectable({
  providedIn: 'root'
})
export class PartnerWorkshopApi extends EventsApiBase {
  getProgramTypeDisplayNames(): Observable<ProgramTypeDisplayNames[]> {
    return this.get<ProgramTypeDisplayNames[]>(
      'api/EventAdmin/GetProgramTypeDisplayNames',
      {}
    ) as Observable<ProgramTypeDisplayNames[]>;
  }

  getEventTypeDropDown(): Observable<EventType[]> {
    return this.get<EventType[]>(
      'api/EventType/GetEventTypes',
      {}
    ) as Observable<EventType[]>;
  }

  getProgramTypeDropDown(): Observable<ProgramType[]> {
    return this.get<ProgramType[]>(
      'api/EventType/GetProgramTypes',
      {}
    ) as Observable<ProgramType[]>;
  }

  getPartnerWorkshopHistory(
    workshopType: number,
    page?: number,
    pageSize?: number
  ): Observable<PagedResult<PartnerWorkshopHistory>> {
    const pgIdx = page ? page : 0;
    const pgSize = pageSize ? pageSize : 0;
    return this.get<PagedResult<PartnerWorkshopHistory>>(
      `api/EventAdmin/GetHistory/${workshopType}?page=${pgIdx}&pageSize=${pgSize}`,
      {}
    ) as Observable<PagedResult<PartnerWorkshopHistory>>;
  }

  validatePartnerWorkshopPartnerList(
    workshopTypeId: number,
    partnerExcelFile: any
  ): Observable<PartnerListUploadItem> {
    return this.post<any, PartnerListUploadItem>(
      `api/EventAdmin/ValidatePartnerAccessList/${workshopTypeId}`,
      partnerExcelFile,
      {}
    ) as Observable<PartnerListUploadItem>;
  }

  validatePrivateWorkshopCustomerList(
    workshopType: number,
    partnerExcelFile: any
  ): Observable<CustomerListImportItem> {
    return this.post<any, CustomerListImportItem>(
      `api/EventAdmin/ValidateCustomerList/${workshopType}`,
      partnerExcelFile,
      {}
    ) as Observable<CustomerListImportItem>;
  }

  uploadPartnerWorkshopList(
    workshopTypeId: number,
    partnerExcelFile: any
  ): Observable<PartnerListUploadItem> {
    return this.post<any, PartnerListUploadItem>(
      `api/EventAdmin/UploadPartnerList/${workshopTypeId}`,
      partnerExcelFile,
      {}
    ) as Observable<PartnerListUploadItem>;
  }
  UploadCustomerList(
    workshopTypeId: number,
    partnerExcelFile: any
  ): Observable<PartnerListUploadItem> {
    return this.post<any, PartnerListUploadItem>(
      `api/EventAdmin/UploadCustomerList/${workshopTypeId}`,
      partnerExcelFile,
      {}
    ) as Observable<PartnerListUploadItem>;
  }

  getDownloadFileUrl(
    downloadModal: BlobFileDownloadRequestModel
  ): Observable<string> {
    return this.post<BlobFileDownloadRequestModel, BlobFileSasUrl>(
      'api/EventAdmin/GetBlobSasContent',
      downloadModal,
      {}
    ).pipe(map(s => s.blobUrl + s.sasToken)) as Observable<string>;
  }

  getAgreedPartnerDetails(
    partnerDetailsRequest: AgreementPartnerDetailsRequest
  ): Observable<List<AgreementPartnerDetails>> {
    return this.post<
      AgreementPartnerDetailsRequest,
      List<AgreementPartnerDetails>
    >(
      `api/EventAdmin/GetAgreedPartnerDetails`,
      partnerDetailsRequest,
      {}
    ) as Observable<List<AgreementPartnerDetails>>;
  }

  getEventTargetProductDropDown(): Observable<EventTargetProduct[]> {
    return this.get<EventTargetProduct[]>(
      'api/EventDashboard/EventTargetProduct',
      {}
    ) as Observable<EventTargetProduct[]>;
  }
}
